import { isHexColour } from '@volee/ui'

import { coloursOf, type KitColourName, type KitFields } from './kit-fields.ts'
import { KIT_DESIGNS, messages } from '../messages/index.ts'

const ui = messages.kits

/** What each colour of a kit is called: on the form's fields and in the drawing's words. */
export const COLOUR_LABELS: Record<KitColourName, string> = {
  primaryColor: ui.primaryColor,
  secondaryColor: ui.secondaryColor,
  shortsColor: ui.shortsColor,
}

/** The design, and the colours not chosen yet: the drawing's own rule for empty. A colour chosen
 *  is never spelled, a code says nothing to the ear and none has a name. */
export function kitLabel(fields: KitFields): string {
  const missing = coloursOf(fields.design)
    .filter((name) => !isHexColour(fields[name]))
    .map((name) => `${COLOUR_LABELS[name]} ${ui.notChosen}`)
  const design = KIT_DESIGNS[fields.design]
  return missing.length === 0 ? design : `${design}: ${missing.join(', ')}`
}
